import logo from '../Assets/Images/logo.png';

const config = {
	kadroUrl: 'https://www.kadro.co',
	logo,
	topbarTitle: 'سامانه رزرو عکاسی کادرو',
};

export const tileLayerSrc = 'https://map.kadro.co/styles/osm-bright/512/{z}/{x}/{y}.png';

export default config;
